import React from "react";
import "./Header.scss";
import logo from "../media/logo.svg";
import RoundedButton from "../RoundedButton/RoundedButton";

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-section-1">
          <a href="/" className="logo">
            <img alt="Com2Cloud logo" src={logo} />
          </a>
          <nav className="navigation">
            <a href="/">
              <div>About Us</div>
            </a>
            <a href="#services">
              <div>Services</div>
            </a>
            <a href="/blog">
              <div>Blog</div>
            </a>
          </nav>
        </div>
        <div className="header-section-2">
          <div className="contact">
            <a href="#contact">
              <RoundedButton>Contact Us</RoundedButton>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
